import _ from 'lodash'
import { Map, Record } from 'immutable'

import { SET_BUTTONS_ARRAY_POSITION } from './constants'
import { TOGGLE_BUTTONS_ARRAY_BUTTON, CHANGE_BUTTONS_ARRAY_BUTTON } from './components/ConnectButton/constants'

const ButtonsArrayRecord = new Record({
    data: Map(),
    position: 0,
    maxPosition: 0,
})

export default (state = new ButtonsArrayRecord(), action, buttonsArrayName) => {
    switch (action.type) {
        case TOGGLE_BUTTONS_ARRAY_BUTTON: {
            const { name } = action.data
            const isActive = state.getIn([buttonsArrayName, 'data', name], false)

            return state.setIn([buttonsArrayName, 'data', name], !isActive)
        }
        case CHANGE_BUTTONS_ARRAY_BUTTON: {
            const { name, value } = action.data

            return state.setIn([buttonsArrayName, 'data', name], value)
        }
        case SET_BUTTONS_ARRAY_POSITION: {
            const position = _.get(action, 'data.position', 0)
            const maxPosition = _.get(action, 'data.maxPosition', 0)

            return state
                .setIn([buttonsArrayName, 'position'], position)
                .setIn([buttonsArrayName, 'maxPosition'], maxPosition)
        }
        default:
            return state
    }
}
